@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.options {
  display: flex;
  flex-direction: column;
  gap: 16px;

  @include for-desktop-only {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

.image {
  position: absolute;
  right: -95px;
  bottom: -120px;
  transform: scale(0.4);
}

.scrollContainer {
  margin-top: 50px;
}
